import { useState } from "react";
import { Button } from "../components/ui/button";

export default function AgeGate({ onConfirm }) {
  const [declined, setDeclined] = useState(false);

  if (declined) {
    return (
      <div className="fixed inset-0 z-[100] grain flex items-center justify-center bg-background p-6">
        <div className="max-w-md text-center animate-fade-up">
          <h1 className="font-display text-4xl mb-4">Come back another time</h1>
          <p className="text-muted-foreground leading-relaxed">
            WhisperTales is an adults-only platform. You must be 18 or older to enter. This
            experience is not available to you.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[100] grain flex items-center justify-center bg-background p-6" data-testid="age-gate">
      <div className="max-w-lg w-full animate-fade-up">
        <div className="mb-8">
          <span className="uppercase tracking-[0.3em] text-xs text-gold">WhisperTales</span>
          <h1 className="font-display text-5xl md:text-6xl leading-[1.05] mt-4">
            An intimate world of<br />audio, told in whispers.
          </h1>
        </div>
        <div className="glass border rounded-xl p-8">
          <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground mb-3">Age Verification</p>
          <h2 className="font-display text-2xl mb-4">Are you 18 or older?</h2>
          <p className="text-muted-foreground text-sm leading-relaxed mb-6">
            This platform contains mature, adult-oriented content intended for adults only. By entering, you confirm
            you are of legal age in your jurisdiction and consent to viewing mature material.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              data-testid="age-gate-confirm"
              onClick={onConfirm}
              className="flex-1 bg-primary hover:bg-primary/90 text-primary-foreground shadow-[0_0_15px_rgba(155,27,48,0.3)] transition-colors duration-300"
            >
              I am 18 or older — Enter
            </Button>
            <Button
              data-testid="age-gate-decline"
              variant="outline"
              onClick={() => setDeclined(true)}
              className="flex-1 border-white/10 bg-transparent hover:bg-white/5 transition-colors duration-300"
            >
              I am under 18
            </Button>
          </div>
        </div>
        <p className="text-xs text-muted-foreground/70 mt-6 leading-relaxed">
          Access is restricted in certain regions. Where required by law, additional ID-based age verification may be requested.
        </p>
      </div>
    </div>
  );
}
